<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.department') }} > {{ $t('sidebar.all') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <base-table
        :pagination="pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('apps.hrm.message.name') }}</th>
              <th style="width: 20%;">{{ $t('apps.hrm.message.appliedcount') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="empty"
                colspan="2"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in data"
              :key="index"
            >
              <td>
                <router-link
                  :to="{
                    name: 'DepartmentEdit',
                    query: {
                      id: item.depId,
                      name: item.name,
                    }
                }">
                  {{ item.name }}
                </router-link>
              </td>
              <td>
                {{ item.appliedCount }}
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [tablePaginateMixin, userPermissionMixin],

  data () {
    return {
      loading: true,
      query: {
        page: this.$route.query.page || 1,
      },
    }
  },

  computed: {
    ...mapState('hrm', {
      data: 'departmentList',
    }),
  },

  watch: {
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.fetchData()
      }
    },
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.hrm.title'),
      current: {
        app_name: 'hrm',
        app_id: 13,
        module_id: 2,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('hrm', {
      'getDepartmentList': 'getDepartmentList',
    }),
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.getDepartmentList({
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
      })
      this.loading = false
      this.showFinish(this.$Progress)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/hrm/department/List.vue